// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 4.18 4.3 C 3.88 5.29 3.2 6.16 2.47 6.88 C 1.77 7.57 1.42 8.24 1.42 9.04 C 1.42 10.62 2.63 11.8 4.18 11.8 C 5.73 11.8 6.94 10.62 6.94 9.04 C 6.94 8.24 6.59 7.57 5.89 6.88 C 5.16 6.16 4.48 5.29 4.18 4.3 Z',
  'M7.31 5.33C7.97 4.37 8.59 3.39 8.96 2.56C9.17 2.08 9.42 1.55 9.7 1.55C9.98 1.55 10.23 2.08 10.44 2.56C11 3.83 12.15 5.45 13.15 6.8C14.1 8.07 14.4 9.17 14.4 10C14.4 12.43 12.3 14.4 9.7 14.4C8.5 14.4 7.41 13.98 6.58 13.29',
];
